import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export interface ClubMembersReportOptions {
    status: string;
    lastPaidYear: number | null;
}

@Component({
    selector: 'app-club-members-report-modal',
    templateUrl: './club-members-report-modal.component.html',
    styleUrls: ['./club-members-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatSelect, FormsModule, MatOption, MatCheckbox, MatDialogActions, MatButton, MatIcon]
})
export class ClubMembersReportModalComponent {
    status = 'all';
    filterByYear = false;
    lastPaidYear: number | null = null;

    readonly currentYear = new Date().getFullYear();
    readonly yearOptions: number[] = Array.from({ length: 10 }, (_, i) => this.currentYear - i);

    constructor(public dialogRef: MatDialogRef<ClubMembersReportModalComponent>) {}

    confirm(): void {
        const result: ClubMembersReportOptions = {
            status: this.status,
            lastPaidYear: this.filterByYear ? this.lastPaidYear : null,
        };
        this.dialogRef.close(result);
    }

    cancel(): void {
        this.dialogRef.close(false);
    }
}
